module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/DroidKufi-Regular.a9b030e2.ttf";